import actions from '../actions';
import { ReducerBuilder } from './reducer-builder';

const defaultState = {
  clientHashId: null,
  accessToken: null,
  userEmail: null,
  userInfo: null,
  linkedAccountsResponse: null,
};

const reducer = new ReducerBuilder(defaultState)
  .handle(actions.app.auth.logIntoClientSuccess, (state, action) => ({
    ...state,
    clientHashId: action.payload.data.hashId,
  }))
  .handle(actions.app.auth.setAccessToken, (state, action) => ({
    ...state,
    accessToken: action.payload.token,
  }))
  .handle(actions.app.auth.setUserEmail, (state, action) => ({
    ...state,
    userEmail: action.payload.email,
  }))
  .handle(actions.app.auth.getUserInfoSuccess, (state, action) => ({
    ...state,
    userInfo: action.payload.userInfo,
    userEmail: action.payload.userInfo.email,
  }))
  .handle(actions.app.auth.checkLinkedAccountsSuccess, (state, action) => ({
    ...state,
    linkedAccountsResponse: action.payload.response,
  }))
  .handle(actions.app.data.registerClientSuccess, (state, action) => ({
    ...state,
    clientHashId: action.payload.data.hashId,
  }))
  .handle(actions.app.auth.logoutSuccess, (state) => ({
    ...state,
    clientHashId: null,
    accessToken: null,
    userEmail: null,
    userInfo: null,
    linkedAccountsResponse: null,
  }))
  .done();

export default reducer;
